import { call, put, takeEvery } from 'redux-saga/effects';
import { bigCommerceActionCreators, BigCommerceApiKeys, DeleteBigCommerceShipMethod } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../bigCommerceApi';

function* deleteBigCommerceShipMethod(action: DeleteBigCommerceShipMethod) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<number> = yield call(
    api.deleteBigCommerceShipMethod,
    action.payload.bigCommerceShipTypeMapId
  );

  if (!response.requestFailed && response.value) {
    if (response.value) {
      yield put(bigCommerceActionCreators.removeShipMethod(response.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteBigCommerceShipMethod() {
  yield takeEvery(BigCommerceApiKeys.DELETE_BIG_COMMERCE_SHIP_METHOD, deleteBigCommerceShipMethod);
}
